import { accents } from "../components/LandingPage/v2/primitives";

/**
 * Per-division theming for the business-division landings and the home
 * section: accent color, cinema mode and particle sculpture. Shared by the
 * landing page (static paths + theming) and the journey rail.
 * Order matters: it is the journey order shown on the home and on the rail.
 */
const DIVISION_THEMES = {
	acceleration: {
		accent: accents.green,
		mode: "accelerator",
		sculpture: "bulb",
	},
	disruption: {
		accent: accents.cyan,
		mode: "liftoff",
		sculpture: "rocket",
	},
	expansion: {
		accent: accents.violet,
		mode: "expansion",
		sculpture: "globe",
	},
};

export default DIVISION_THEMES;
